import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Star } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function ReviewDialog({ booking, open, onClose, onSaved }) {
  const [rating, setRating] = useState(5);
  const [hover, setHover] = useState(0);
  const [comment, setComment] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    setSaving(true);
    try {
      await api.post(`/bookings/${booking.id}/review`, { rating, comment });
      toast.success("Thanks for your review!");
      onSaved?.();
      onClose();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Couldn't submit review");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Review {booking?.hostel_name}</DialogTitle>
        </DialogHeader>
        <div className="space-y-5">
          <div>
            <div className="text-xs tracking-widest uppercase font-bold text-slate-500 mb-2">Your rating</div>
            <div className="flex gap-1">
              {[1, 2, 3, 4, 5].map((n) => (
                <button
                  key={n}
                  data-testid={`review-star-${n}`}
                  type="button"
                  onMouseEnter={() => setHover(n)}
                  onMouseLeave={() => setHover(0)}
                  onClick={() => setRating(n)}
                  className="p-1 active:scale-90 transition-transform"
                >
                  <Star
                    size={32}
                    className={
                      (hover || rating) >= n
                        ? "fill-amber-600 text-amber-600"
                        : "text-slate-300"
                    }
                  />
                </button>
              ))}
            </div>
          </div>
          <div>
            <div className="text-xs tracking-widest uppercase font-bold text-slate-500 mb-2">
              Tell other students (optional)
            </div>
            <Textarea
              data-testid="review-comment"
              rows={4}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder="Was it clean? Safe? Close to your coaching?"
              maxLength={1000}
            />
          </div>
          <Button
            data-testid="review-submit"
            onClick={submit}
            disabled={saving}
            className="w-full h-12 rounded-full bg-orange-800 hover:bg-orange-800 text-white active:scale-95 transition-transform"
          >
            {saving ? "Submitting…" : "Submit review"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
